import { Field, useFormikContext } from 'formik';
import React from 'react';

import { TextArea } from 'Components/FormFields/TextArea/TextArea';
import { getAppText } from 'Utils/text';
import { EmailCancellationFormValues } from './emailCancellationForm.values';

interface EmailCancellationFormFieldsProps {
  submitSuccess: boolean;
}

export const EmailCancellationFormFields = ({
  submitSuccess,
}: EmailCancellationFormFieldsProps): React.ReactElement => {
  const { errors, touched } = useFormikContext<EmailCancellationFormValues>();
  return (
    <Field
      className="data-hj-suppress"
      as={TextArea}
      rows={4}
      fluid
      large
      label={getAppText('cancelInsurance.manualMessage.label')}
      name="manualMessage"
      disabled={submitSuccess}
      error={touched.manualMessage && errors.manualMessage}
    />
  );
};
